import { NamedProperty } from "sprint-common-web";

import { SearchMoviesResponseItem } from "../../../common/api/catalogue-api/movie/SearchMoviesResponse";

export interface MovieSearchItem {
    id: string;
    name: string;
    distributors: string;
    types: number[];
    assetsCount: number;
}

interface MovieAssetsData {
    assetsCount: number;
    types: number[];
}

export const mapToMovieSearchItem = (
    item: SearchMoviesResponseItem,
    { assetsCount, types }: MovieAssetsData
): MovieSearchItem => ({
    id: item.id,
    name: item.name,
    distributors: item.distributors.map((distributor: NamedProperty) => distributor.name).join(", "),
    types,
    assetsCount
});
